'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _OMAutocompleteInput = require('../../components/OMComponents/OMAutocompleteInput/OMAutocompleteInput');var _OMAutocompleteInput2 = _interopRequireDefault(_OMAutocompleteInput);

var _constants = require('../../constants');
var _highlightSuggestion = require('../../helpers/highlightSuggestion');var _highlightSuggestion2 = _interopRequireDefault(_highlightSuggestion);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var PublishAutocompleteLocationInput = function (_Component) {_inherits(PublishAutocompleteLocationInput, _Component);function PublishAutocompleteLocationInput() {var _temp, _this, _ret;_classCallCheck(this, PublishAutocompleteLocationInput);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      prefilled: false,
      suggestions: [],
      value: '' }, _this.














    onKeyDown = function (event) {
      if (event.keyCode === _constants.enterKey) {
        event.preventDefault();
        _this.setState({
          value: event.target.value },
        function () {
          document.activeElement.blur();
        });
      }
    }, _this.

    getSuggestionValue = function (suggestion) {return suggestion ?
      (0, _get2.default)(suggestion, 'structured_formatting.main_text', '') || (0, _get2.default)(suggestion, 'description', '')
      // get(suggestion, 'description', '') || get(suggestion, 'structured_formatting.main_text', '')
      : '';}, _this.

    getInputValue = function (value) {
      value = (value || '').trim();
      _this.setState({ value: value });
      if (value) {
        _this.props.receiveSuggestions(Object.assign({}, _this.props.params, { query: value }));
      }
      _this.props.onQueryStringChange(_this.props.params.type, value);
    }, _this.

    highLightSuggestion = function (suggestion, ctx) {return (
        (0, _highlightSuggestion2.default)(Object.assign({}, suggestion, { address: _this.getSuggestionValue(suggestion) }), ctx));}, _this.

    handleBlur = function (evt) {
      evt.target.setAttribute('autocomplete', evt.target.name);
      _this.setState({
        suggestions: [] });

      _this.props.handleBlur(_this.state.value);
    }, _this.

    handleFocus = function (evt) {
      evt.target.setAttribute('autocomplete', 'off');
      _this.setState({
        suggestions: [] },
      function () {_this.props.handleFocus(_this.props.params.type);});
    }, _temp), _possibleConstructorReturn(_this, _ret);}PublishAutocompleteLocationInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var _ref$suggestions = _ref.suggestions,suggestions = _ref$suggestions === undefined ? [] : _ref$suggestions,_ref$fieldValue = _ref.fieldValue,fieldValue = _ref$fieldValue === undefined ? '' : _ref$fieldValue,_ref$initialValue = _ref.initialValue,initialValue = _ref$initialValue === undefined ? '' : _ref$initialValue,inFocus = _ref.inFocus;var stateModifier = { suggestions: suggestions };if (this.state.value && !fieldValue && !inFocus) {stateModifier.value = '';}if (initialValue && !this.state.prefilled) {stateModifier.value = initialValue;stateModifier.prefilled = true;}this.setState(Object.assign({}, stateModifier));};PublishAutocompleteLocationInput.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_OMAutocompleteInput2.default, {
        inputName: this.props.name,
        inputValue: this.state.value,
        initialValue: this.props.initialValue,
        placeholder: this.props.placeholder,
        theme: _constants.inputStyleTheme,
        getInputValue: this.getInputValue,
        suggestions: this.state.suggestions.slice(0, 5),
        getSuggestionValue: this.getSuggestionValue,
        selectedSuggestion: this.props.searchSelectedOption,
        onKeyDown: this.onKeyDown,
        deferRequestBy: 300,
        className: this.props.className,
        renderSuggestions: this.highLightSuggestion,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        isMobile: this.props.isMobile,
        allowEmptyInput: true,
        isValid: true }));


  };return PublishAutocompleteLocationInput;}(_react.Component);


PublishAutocompleteLocationInput.propTypes = {
  name: _propTypes2.default.string.isRequired,
  suggestions: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  receiveSuggestions: _propTypes2.default.func,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  onQueryStringChange: _propTypes2.default.func,
  fieldValue: _propTypes2.default.string,
  requestString: _propTypes2.default.func,
  handleFocus: _propTypes2.default.func.isRequired,
  handleBlur: _propTypes2.default.func,
  params: _propTypes2.default.object.isRequired,
  searchSelectedOption: _propTypes2.default.func,
  inFocus: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  initialValue: _propTypes2.default.string };exports.default =


PublishAutocompleteLocationInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishAutocompleteLocationInput/PublishAutocompleteLocationInput.js
// module id = 1230
// module chunks = 0